// // // import React from "react";
// // // import Button from "../Button/Button";
// // // import "./Hero.css";

// // // const Hero = () => {
// // //   const stats = [
// // //     { value: "€1,000,000", label: "in taxes returned" },
// // //     { value: "1,000+", label: "companies formed" },
// // //     { value: "8,000+", label: "happy clients" },
// // //   ];

// // //   return (
// // //     <section className="hero section bg-white" id="home">
// // //       <div className="container">
// // //         <div className="hero-content">
// // //           <h1 className="hero-title">accounting for a successful future</h1>
// // //           <p className="hero-subtitle">
// // //             we offer trusted taxation and accounting services to help expats,
// // //             employees, contractors and entrepreneurs in Ireland
// // //           </p>

// // //           <Button
// // //             type="primary"
// // //             size="lg"
// // //             text="book appointment"
// // //             className="hero-cta"
// // //             onClick={() => alert("Booking appointment...")}
// // //           />

// // //           <div className="stats-container">
// // //             {stats.map((stat, index) => (
// // //               <div key={index} className="stat-item">
// // //                 <div className="stat-value">{stat.value}</div>
// // //                 <div className="stat-label">{stat.label}</div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Hero;

// // import React from "react";
// // import Button from "../Button/Button";
// // import heroImage from "../../images/homeScreenImage.jpg";
// // import "./Hero.css";

// // const Hero = () => {
// //   const stats = [
// //     // { value: "€1,000,000", label: "in taxes returned" },
// //     // { value: "1,000+", label: "companies formed" },
// //     // { value: "8,000+", label: "happy clients" },
// //   ];

// //   return (
// //     <section className="hero" id="home">
// //       <div className="container hero-grid">
// //         {/* LEFT IMAGE */}
// //         <div className="hero-image">
// //           <img src={heroImage} alt="Accounting Illustration" />
// //         </div>

// //         {/* RIGHT CONTENT */}
// //         <div className="hero-content">
// //           <h1 className="hero-title">accounting for a successful future</h1>

// //           <p className="hero-subtitle">
// //             We offer trusted taxation and accounting services to help expats,
// //             employees, contractors and entrepreneurs in Ireland.
// //           </p>

// //           <Button
// //             type="primary"
// //             size="lg"
// //             text="book appointment"
// //             className="hero-cta"
// //             onClick={() => alert("Booking appointment is coming...")}
// //           />

// //           <div className="stats-container">
// //             {stats.map((stat, index) => (
// //               <div key={index} className="stat-item">
// //                 <div className="stat-value">{stat.value}</div>
// //                 <div className="stat-label">{stat.label}</div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Hero;

// import React, { useState } from "react";
// import Button from "../Button/Button";
// import BookingModal from "../BookingModal/BookingModal";
// import heroImage from "../../images/hnu.png";
// import "./Hero.css";

// const Hero = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const openModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const stats = [];

//   return (
//     <>
//       <section className="hero" id="home">
//         <div className="container hero-grid">
//           {/* LEFT IMAGE */}
//           <div className="hero-image">
//             <img src={heroImage} alt="Accounting Illustration" />
//           </div>

//           {/* RIGHT CONTENT */}
//           <div className="hero-content">
//             <h1 className="hero-title">Accounting with Lasting Success</h1>

//             <p className="hero-subtitle">
//               We offer trusted taxation and accounting services to help expats,
//               employees, contractors and entrepreneurs in Ireland. With Helping
//               individuals and businesses across Ireland navigate their
//               accounting, taxation, and compliance requirements with confidence
//               and precision.
//             </p>

//             <Button
//               type="primary"
//               size="lg"
//               text="book appointment"
//               className="hero-cta"
//               onClick={openModal}
//             />

//             <div className="stats-container">
//               {stats.map((stat, index) => (
//                 <div key={index} className="stat-item">
//                   <div className="stat-value">{stat.value}</div>
//                   <div className="stat-label">{stat.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       <BookingModal isOpen={isModalOpen} onClose={closeModal} />
//     </>
//   );
// };

// export default Hero;

import React, { useState } from "react";
import Button from "../Button/Button";
import BookingModal from "../BookingModal/BookingModal";
import heroImage from "../../images/hnu.png";
import "./Hero.css";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const stats = [];

  return (
    <>
      <section className="hero" id="home">
        <div className="container hero-grid">
          {/* IMAGE AT TOP WITH CENTER ALIGNMENT */}
          <div className="hero-image-wrapper">
            <div className="hero-image">
              <img
                src={heroImage}
                alt="Accounting Illustration"
                className="hero-img"
              />
            </div>
          </div>

          {/* CONTENT UNDER THE IMAGE - CENTERED */}
          <div className="hero-content">
            <h1 className="hero-title">Accounting with Lasting Success</h1>

            <p className="hero-subtitle">
              We offer trusted taxation and accounting services to help expats,
              employees, contractors and entrepreneurs in Ireland. With Helping
              individuals and businesses across Ireland navigate their
              accounting, taxation, and compliance requirements with confidence
              and precision.
            </p>

            <Button
              type="primary"
              size="lg"
              text="book appointment"
              className="hero-cta"
              onClick={openModal}
            />

            <div className="stats-container">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Hero;
